import React from 'react';
import styled from 'styled-components';
import { FaRegCheckCircle, FaQrcode, FaMobile, FaShieldAlt } from 'react-icons/fa';
import SectionTitle from '../common/SectionTitle';
import { theme } from '../../styles/GlobalStyles';

const SectionContainer = styled.section`
  padding: 5rem 0;
  background-color: ${theme.surfaceAlt};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 700px; height: 400px;
    background: radial-gradient(ellipse, rgba(97,93,255,0.07) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 1;
`;

const StepCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 1.5rem;
  background: ${theme.cardBg};
  border: 1px solid ${theme.border};
  border-radius: 18px;
  backdrop-filter: blur(16px);
  box-shadow: ${theme.cardShadow};
  transition: all 0.3s ease;
  min-width: 220px;
  max-width: 260px;
  flex: 1;

  &:hover {
    background: ${theme.cardBgHover};
    border-color: rgba(97,93,255,0.3);
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(97,93,255,0.2), ${theme.cardShadow};
  }
`;

const StepNum = styled.div`
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: ${theme.textDim};
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;

const IconWrapper = styled.div`
  width: 68px; height: 68px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(97,93,255,0.2), rgba(61,217,235,0.12));
  border: 1px solid rgba(97,93,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  font-size: 1.6rem;
  color: #615DFF;
  transition: all 0.3s ease;

  ${StepCard}:hover & {
    background: linear-gradient(135deg, rgba(97,93,255,0.35), rgba(61,217,235,0.2));
    color: #3DD9EB;
    box-shadow: 0 0 24px rgba(97,93,255,0.3);
  }
`;

const CardTitle = styled.h3`font-size:1rem;font-weight:600;color:${theme.text};margin-bottom:0.6rem;`;
const CardDesc  = styled.p`font-size:0.875rem;color:${theme.textMuted};margin:0;line-height:1.6;`;

const steps = [
  { num:'Step 01', icon:<FaRegCheckCircle />, title:'Register Products',        desc:'Brands onboard products to the Prodseal platform in batches or individually.' },
  { num:'Step 02', icon:<FaQrcode />,         title:'Generate Secure QR Codes', desc:'Unique cryptographic codes for each unit, optionally scratch-protected.' },
  { num:'Step 03', icon:<FaMobile />,          title:'Consumer Verification',    desc:'Customer scans with any phone — sees instant authenticity result, no app needed.' },
  { num:'Step 04', icon:<FaShieldAlt />,       title:'Warranty Seal',            desc:'One scan — authenticity check + automatic digital warranty activation.' },
];

const HowItWorksSection = () => (
  <SectionContainer id="howitworks">
    <SectionTitle>How It Works – Simple. Secure. Seamless.</SectionTitle>
    <CardContainer>
      {steps.map((s) => (
        <StepCard key={s.num}>
          <StepNum>{s.num}</StepNum>
          <IconWrapper>{s.icon}</IconWrapper>
          <CardTitle>{s.title}</CardTitle>
          <CardDesc>{s.desc}</CardDesc>
        </StepCard>
      ))}
    </CardContainer>
  </SectionContainer>
);

export default HowItWorksSection;
